/** Host serving library assets when no library asset host is configured. */
const LEGACY_LIBRARY_ASSET_HOST = 'https://cdn.assets.scratch.mit.edu';

/**
 * Build the URL a library asset is fetched from, in the shape Scratch's asset service uses.
 * @param {string} assetId - the md5 of the asset.
 * @param {string} dataFormat - the asset's file extension.
 * @param {string} [host] - the host serving the assets, without a trailing slash.
 *   When omitted or empty, the public Scratch asset service is used.
 * @returns {string} - the URL to fetch the asset from.
 */
export const customAssets = [
    '9d2b256728417f57326ed57b64f7630b',
    '72c5d407857b80713db8866cc4800907',
    'd3143ea5f5a92a60b395b41d9d3962ca',
    'd95d61950df469a156d08e1567cc3ff4',
    '2b14d11e67b245134e4c8401414262a9',
    'ec6c51344446b92e4fc1fb490c56c3ed',
    '534fec660fae59dba6948e46fd3eb9e0',
    'dca5c19aeade5f2a650be51d77382b1f',
    'af0951379d9a77bccca1cb69fe68a650',
    '52adcf5583bb0e92b4caebdfea4f73fe',
    '96bb0d8cb8bfd727936d8aa6e476efff',
    '795206e2c0384010fdb15474b495d8f8',
    '608882ba34825bc3788e52e2ada9e619',
    '4923cb194dcc86198545b12245f8836d',
    '060e136668d5efbcc831e4d9d43c7fe4',
    'cd6458fb477948f2eb2bdaed6643d9b6',
    '78d04ed3de4a3b2d8bc132fb7de0c4cf',
    '3d3854c069a03fe32ed274f4ba82bbfe',
    'adc714ea4d92e85f929e5333c7eef8f1',
    '3defd12f7c50a9bec0717aae09cdbf0b',
    '6689ff7c8c99fffba82173b5d4d687ad',
    '1379bb382299f113cf524d4877e371d0',
    'eeef7b716107c0727f1e3474ba826817',
    '3bcd0c2a77772a85bbc70e7e50913992',
    'a9ab7960e5cad6caa8315bd0cfeb1038'
];

export const buildLibraryAssetUrl = (assetId: string, dataFormat: string, host?: string): string => {
    if (customAssets.includes(assetId)) {
        return `./static/${assetId}.${dataFormat}`;
    }
    if (!host) {
        return `${LEGACY_LIBRARY_ASSET_HOST}/internalapi/asset/${assetId}.${dataFormat}/get/`;
    }
    return `${host}/internalapi/asset/${assetId}.${dataFormat}/get/`;
};
